export const IconPower = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <mask
        id="IconPower_svg__a"
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#IconPower_svg__a)">
        <path d="M12 22a9.7 9.7 0 0 1-3.9-.788 10.1 10.1 0 0 1-3.175-2.137q-1.35-1.35-2.137-3.175A9.7 9.7 0 0 1 2 12q0-1.825.612-3.463Q3.226 6.9 4.3 5.6q.274-.35.663-.325.387.025.662.275t.362.65-.262.825a8.4 8.4 0 0 0-1.262 2.287A7.8 7.8 0 0 0 4 12q0 3.35 2.325 5.675T12 20t5.675-2.325T20 12q0-1.425-.462-2.687a8.4 8.4 0 0 0-1.263-2.288q-.35-.425-.262-.825t.362-.65.663-.275.662.325a10.2 10.2 0 0 1 1.688 2.938A9.8 9.8 0 0 1 22 12a9.7 9.7 0 0 1-.788 3.9 10.1 10.1 0 0 1-2.137 3.175q-1.35 1.35-3.175 2.137A9.7 9.7 0 0 1 12 22m0-9a.97.97 0 0 1-.713-.287A.97.97 0 0 1 11 12V3q0-.424.287-.712A.97.97 0 0 1 12 2q.424 0 .713.288Q13 2.575 13 3v9q0 .424-.287.713A.97.97 0 0 1 12 13" />
      </g>
    </svg>
  );
};
